export const NONCE_FAKE_PROCESSOR_DECLINED = 'fake-processor-declined-visa-nonce';
export const NONCE_FAKE_LUHN_INVALID  = 'fake-luhn-invalid-nonce';
export const NONCE_FAKE_CONSUMED = 'fake-consumed-nonce';

export const DEBUG_NONCE_OVERRIDE_OPTIONS: {label: string, value: string }[] = [
  { label: 'Get a real nonce from Braintree (normal behaviour)', value: '' },
  { label: 'Processor declined', value: NONCE_FAKE_PROCESSOR_DECLINED },
  { label: 'Luhn-invalid card', value: NONCE_FAKE_LUHN_INVALID },
  { label: 'Nonce already consumed', value: NONCE_FAKE_CONSUMED },
];
